import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { Button, SxProps, Theme } from "@mui/material";
import { PRIMITIVE, px } from "@/tokens/design-tokens";
import { SCRIBE_COPY_TRANSCRIPT_LABELS, SCRIBE_V2_COLORS } from "../constants";

export interface CopyTranscriptButtonProps {
  onCopy: () => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const CopyTranscriptButton = ({
  onCopy,
  disabled = false,
  sx,
}: CopyTranscriptButtonProps) => (
  <Button
    size="small"
    disableRipple
    disabled={disabled}
    onClick={onCopy}
    startIcon={<ContentCopyOutlinedIcon />}
    sx={[
      {
        minWidth: "auto",
        p: 0,
        flexShrink: 0,
        color: SCRIBE_V2_COLORS.panelLabel,
        fontSize: px(PRIMITIVE.typography.fontSize.body.b6),
        fontWeight: PRIMITIVE.typography.fontWeight.semiBold,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        "& .MuiButton-startIcon svg": {
          fontSize: px(PRIMITIVE.spacing[16]),
        },
        "&:hover": {
          backgroundColor: "transparent",
          color: SCRIBE_V2_COLORS.textPrimary,
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {SCRIBE_COPY_TRANSCRIPT_LABELS.BUTTON}
  </Button>
);

export default CopyTranscriptButton;
